import { createFileRoute } from '@tanstack/react-router';
import ImportRefuelingsWizard from '../../components/ImportRefuelingsWizard/wizard';
import { PERMISSION_IMPORTED_RECORD } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';

export const Route = createFileRoute('/_authenticated/expenses_import/wizard')({
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_IMPORTED_RECORD, ['create'], '/unauthorized', context);

    return {
      ...context,
      documentTitle: {
        main: 'table.addBtn',
        suffix: 'tab.expense/import/record',
      },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: ExpenseImportWizardRoute,
});

function ExpenseImportWizardRoute() {
  return <ImportRefuelingsWizard />;
}
